define('components/MainAlert/MainAlertComponent',[
    'core/can',
    'models/Credential',
    'text!components/MainAlert/MainAlertView.stache',
], function (can, Credential, template) {
    can.Component.extend({
        tag: 'ax-main-alert',
        template: template,
        scope: function (attrs, parentScope, el) {
            var scope = new can.Map({
                hasMultipleInvalidCred: can.compute(function () {
                    var total = scope.attr('invalidCredentials');
                    return total && total.length > 1;
                })
            });

            return scope;
        },
        events: {
            'inserted': function () {
                var self = this,
                    scope = self.scope;
                Credential.findAll().done(function (credentials) {
                    scope.attr('credentials', credentials);
                    self.credentialsUpdated();
                });
            },

            '.edit click':function(el){
                App.loadModal('modals/credential/CredentialModal', { model: el.data('this') });
            },


            'credentialsUpdated': function () {
                var scope = this.scope,
                    credentials = scope.attr('credentials'),
                    invalidCredentials = credentials.filter(function (credential) {
                        return credential.attr('IsVerified') === false;
                    });

                scope.attr('invalidCredentials', invalidCredentials);
            },

            'app:credential:updated': function (el, ev, model) {
                var updatedCredential = this.scope.attr('credentials').findById(model.attr('EntityId'));
                updatedCredential.attr('IsVerified', true);
                this.credentialsUpdated();
            },

            'app:credential:unverified': function (el, ev, Username) {
                var unverifiedCredential = this.scope.attr('credentials').findByProp(Username, 'Username');
                unverifiedCredential.attr('IsVerified', false);
                this.credentialsUpdated();
            },

            'app:credential:created': function (el, ev, options) {
                var model = options.model;
                this.attr('credentials').push(model);
            }
        }
    })
})
;
